<template>
	<el-badge
		class="status-badge"
		is-dot
		:style="{
      height: '8px',
      lineHeight: '8px',
    }"
	></el-badge>
	{{ dictItem.label || "" }}
</template>

<script>
import {getDictItem} from "@/app/dict";
import {computed} from "vue";

export default {
	name: "DictColumn",
	props: {
		prop: {
			type: String,
			required: true,
		},
		row: {
			type: Object,
			required: true,
		},
		column: {
			type: Object,
			required: true,
		},
		view: {
			type: Object,
			required: true,
		},
	},
	setup(props) {
		const val = computed(() => props.row[props.prop] || '');
		const dictItem = computed(
				() => {
					if (props.view.name) {
						return getDictItem(props.view.name, val.value) || {
							color: "#E6E8EB",
							value: val,
							label: val,
						}
					}
					if (props.view.items) {
						return props.view.items.find(i => i.value === val.value) || {
							color: "#E6E8EB",
							value: val,
							label: val,
						}
					}
					return []
				}
			)
		;
		return {
			dictItem,
		};
	},
};
</script>

<style lang="scss" scoped>
.status-badge {
	:deep(.el-badge__content) {
		background-color: v-bind("dictItem.color");
	}
}
</style>
